import { useState, useEffect, useCallback } from 'react';

export const useInfiniteScroll = (
  callback: () => void,
  threshold = 100,
  isLoading = false,
  hasMore = true
) => {
  const [isFetching, setIsFetching] = useState(false);

  const handleScroll = useCallback(() => {
    // Don't trigger if already loading, no more data, or currently fetching
    if (isLoading || !hasMore || isFetching) {
      return;
    }

    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight - threshold) {
      setIsFetching(true);
      callback();
    }
  }, [callback, isFetching, threshold, isLoading, hasMore]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  // Reset isFetching when loading state changes from true to false
  useEffect(() => {
    if (!isLoading && isFetching) {
      setIsFetching(false);
    }
  }, [isLoading, isFetching]);

  return { isFetching };
};